import { isPermissionCheckDisabled } from "../../shared/permissions/permissions"
import { Roles } from "../../shared/permissions/permissionsConfig"
import { getAdmSummary, getAllCustomerGroups, getAssignedCustomerGroups } from "../utils/userHelper"

export const queryCustomerBases = {
  async customerBases(_parent, args, context, _info) {
    const {
      offset,
      limit,
      sort = {
        orderBy: "lastName",
        direction: "asc",
      },
    } = args

    const user = context?.user
    const admData = []
    let total = 0

    if (user.admNumbers) {
      await Promise.all(
        user.admNumbers.map(async (admNumber) => {
          admData.push({
            ...(await getAdmSummary({ admNumber })),
            name: `${user.firstName} ${user.lastName}`,
          })
          total += 1
        }),
      )
    }

    if (user.role === Roles.ADMIN || isPermissionCheckDisabled) {
      const { customerGroupData, total: totalFromDb } = await getAllCustomerGroups({
        limit,
        offset,
        sort,
      })
      total = totalFromDb + 1

      admData.push(...customerGroupData)
    }

    if ([Roles.REGIONAL_LEAD, Roles.ADM_GVL].includes(user.role)) {
      const { customerGroupData, total: totalFromDb } = await getAssignedCustomerGroups({
        employeeNumber: user.employeeNumber,
        limit,
        offset,
        sort,
      })
      total = totalFromDb + 1

      admData.push(...customerGroupData)
    }

    return { items: admData, total: total }
  },
}
